import { WOOL_SHED_PUZZLE_BEAT, WOOL_SHED_PUZZLE_CUES } from '@/story/act2/woolShedPuzzle';
import { WOOL_SHED_REST_BEAT, WOOL_SHED_REST_CUES } from '@/story/act2/woolShedRest';
import { fadeStoryPart } from '@/game/beats/fadeStoryPart';
import type { BeatPartModuleDefinition } from '@/game/beatPartModule';

const noOpFixedStep = (): void => undefined;

export const WOOL_SHED_PUZZLE_PART_MODULE: BeatPartModuleDefinition = {
  beat: 9,
  part: 1,
  room: 'wool-shed',
  create: fadeStoryPart({ beat: WOOL_SHED_PUZZLE_BEAT, cues: WOOL_SHED_PUZZLE_CUES, fixedStep: noOpFixedStep }),
};

export const WOOL_SHED_REST_PART_MODULE: BeatPartModuleDefinition = {
  beat: 9,
  part: 2,
  room: 'wool-shed',
  create: fadeStoryPart({ beat: WOOL_SHED_REST_BEAT, cues: WOOL_SHED_REST_CUES, fixedStep: noOpFixedStep }),
};
